"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStepperContext = exports.StepperContextProvider = void 0;
var react_1 = require("react");
var StepperContext = react_1.createContext(undefined);
exports.StepperContextProvider = StepperContext.Provider;
function useStepperContext() {
    var context = react_1.useContext(StepperContext);
    if (!context) {
        throw new Error('Stepper subcomponents (like Step, StepLabel, StepConnector and StepContent) must be used inside <Stepper>');
    }
    return context;
}
exports.useStepperContext = useStepperContext;
//# sourceMappingURL=useStepperContext.js.map